import { GET_HOBBIES,ADD_HOBBIES,ADD_MORE } from '../actions/actionTypes';

const initialState = {
  hobbiescardData:[],hobbiescardData:[],cardItemDataShow:false,opentost:false,tost_msg:''
};


export default function hobbies(state = initialState, action) {

  switch (action.type) {
     case GET_HOBBIES:
      //alert('jj');
      return{
       ...state,
     
       hobbiescardData: action.getCardData,
       hobbiescardItemData:action.cardItemData,
       cardItemDataShow:action.cardItemDataShow,
       cardItemId:action.cardItemId,
       cardItemVersion:action.cardItemVersion,
       hobbiesArr:action.hobbiesArr,
       hobbiesArr_temp:action.hobbiesArr_temp,
       hobbiesArr_lenght:action.hobbiesArr_lenght,
       view:action.view,
       showHobbies:action.showHobbies,
       showRestriction:action.showRestriction,
       isEdit:action.isEdit

      

      };
      case ADD_HOBBIES:
      
      return{
       ...state,
     
      };
      case ADD_MORE:
      return {
        ...state,
        hobbiesArr:action.hobbiesArr,
        hobbiesArr_lenght:action.hobbiesArr_lenght,
        hobbiesArrnew:action.hobbiesArr,
      }
    default: return state;
  }
};

